import { createContext, useContext } from 'react'
import { Navigate, Outlet } from 'react-router'
import { Cargando } from './Cargando'
import { Ingreso } from './Ingreso'
import { useSesion, type Sesion, type TipoUsuario } from './useSesion'

const ContextoSesion = createContext<Sesion | null>(null)

/** Sesión resuelta, disponible en cualquier pantalla protegida. */
export function useSesionActiva(): Sesion {
  const s = useContext(ContextoSesion)
  if (!s) throw new Error('useSesionActiva sólo se usa dentro de una RutaProtegida')
  return s
}

interface RutaProtegidaProps {
  /** Si se indica, sólo ese tipo de usuario puede entrar; el otro vuelve a la raíz. */
  solo?: TipoUsuario
}

/**
 * Todas las pantallas del portal están detrás del ingreso (§8). Sin sesión
 * se va a la tarjeta; con acceso revocado se muestra el estado del §8.1.
 */
export function RutaProtegida({ solo }: RutaProtegidaProps) {
  const sesion = useSesion()

  if (sesion.estado === 'cargando') return <Cargando />
  if (sesion.estado === 'anonimo') return <Navigate to="/ingreso" replace />
  if (sesion.estado === 'revocado') return <Ingreso estado={{ tipo: 'revocado' }} />
  if (sesion.estado === 'error') return <Navigate to="/" replace />

  if (solo && sesion.usuario.tipo !== solo) return <Navigate to="/" replace />

  return (
    <ContextoSesion.Provider value={sesion}>
      <Outlet />
    </ContextoSesion.Provider>
  )
}
